<template>
    <div class="deal_index_box">
        <!-- 退款查詢 -->
        <div class="deal_title">
            <div>交易管理<span>》</span>退款查詢</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box">
            <div class="deal_content_title">退款查詢</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 退款查詢查詢 -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <el-form-item label="查詢類型：">
                            <el-button>模糊查詢</el-button><el-button type="primary">精準查詢</el-button>
                        </el-form-item>
                        <el-form-item label="申請時間：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center" 
                                unlink-panels
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                            <el-form-item label="退款類型：">
                            <el-select v-model="paymentValue" placeholder="所有付款類型">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="申請人：">
                            <el-input class="money_input money_input01" placeholder="" v-model="proposer" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="退款金額：" class="money_box">
                            <el-input class="money_input" placeholder="" v-model="money1" clearable></el-input>
                        <span>至</span><el-input class="money_input" placeholder="" v-model="money2" clearable></el-input>
                        </el-form-item> 
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                    <el-button type="primary">查詢</el-button>   
                    </div>
                    <!-- 表单 -->
                    <div class="table_download"> 
                        <span>匯出退款紀錄</span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt=""></span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt=""></span>
                    </div>
                    <div>
                        <!-- 表单头 -->
                        <div class="table_header">
                            <div class="table_merchantorder">退款單號</div>
                            <div class="table_money">退款金額</div>
                            <div class="table_status">退款狀態</div>
                            <div class="table_paymenttype">申請人</div>
                            <div class="table_date">申請時間</div>
                            <div class="table_operation">操作</div>
                        </div>
                        <!-- 表单内容 -->
                        <div class="table_content" v-for="item of tableData" :key="item.id">
                            <div class="table_merchantorder">{{item.merchantOrder}}</div>
                            <div class="table_money">{{item.money}}</div>
                            <div class="table_status">{{item.status}}</div>
                            <div class="table_paymenttype">{{item.paymentType}}</div>
                            <div class="table_date">{{item.date}}</div>
                            <div class="table_operation">
                                <span>查看</span>
                            </div>
                        </div>
                        <!-- 表单分页列表 -->
                        <div class="table_pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 30, 50]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalNumber"
                                >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- deal_index_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginDealInquire',
    data() {
        return {
            activeName: "first",
            form:{
            },
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            dateValue: '',
            // 所有付款類型
            options: [{
                value: '類型1',
                label: '退款中'
            }, {
                value: '類型2',
                label: '退款完成'
            }, {
                value: '類型3',
                label: '退款異常'
            }],
            paymentValue: '',
            transactionValue: '',
            proposer: '',
            money1: '',
            money2: '',
            // 表单
            tableData: [{
                id: "001",
                date: '2019-03-14 11:26:11',
                merchantOrder: '201901202239595500001981128428',
                paymentType: '1234567(陳玲)',
                status: '退款中',
                money: 200
            }, {
                id: "002",
                date: '2019-03-14 11:26:11',
                merchantOrder: '201901202239595500001981128428',
                paymentType: '1234567(陳玲)',
                status: '退款完成',
                money: 200
            }, {
                id: "003",
                date: '2019-03-14 11:26:11',
                merchantOrder: '201901202239595500001981128428',
                paymentType: '1234567(陳玲)',
                status: '退款異常',
                money: 200
            }, {
                id: "004",
                date: '2019-03-14 11:26:11',
                merchantOrder: '201901202239595500001981128428',
                paymentType: '1234567(陳玲)',
                status: '退款完成',
                money: 200
            }],
            totalNumber: 72
        // return
        }
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
      },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 0 20px;
        padding-top: 26px;
    }
    .center_box {
        min-width: 900px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .table_download span {
        display: inline-block;
        margin: 10px;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }
     .table_date {
        box-sizing: border-box;
        width: 20%;
        padding-left: 14px;
        padding-right: 10px;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 27%;
        padding: 0 10px;
    }
    .table_paymentorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 23%;
        min-width: 160px;
        padding: 0 10px;
    }
    .table_paymenttype {
        box-sizing: border-box;
        width: 17%;
        padding: 0 10px;
        min-width: 77px;
    }
    .table_status {
        box-sizing: border-box;
        width: 14%;
        padding: 0 10px;
    }
    .table_money {
        box-sizing: border-box;
        text-align: center;
        width: 14%;
        padding: 0 10px;
    }
    /* .table_content .table_money {
        text-align: right;
    } */
    .table_operation {
        padding: 0 10px;
    }
    .table_operation span {
        margin-right: 10px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
</style>
